import { Link } from "react-router-dom";
import { hdmgdjSections } from "@/config/hdmgdjNav";
import type { HdmgdjConfig } from "@/config/hdmgdjConfig";
import { hdmgdjJumpTo } from "@/hooks/hdmgdj/useHdmgdjScroll";

interface HdmgdjFooterProps {
  config: HdmgdjConfig;
}

const HDMGDJ_LOGO =
  "/images/logo.png";

export default function HdmgdjFooter({ config }: HdmgdjFooterProps) {
  const handleJump = (id: string) => (event: { preventDefault: () => void }) => {
    event.preventDefault();
    hdmgdjJumpTo(id);
  };

  return (
    <footer className="bg-secondary-100 text-foreground-800">
      <div className="h-1 w-full hdmgdj-accent-bar" />
      <div className="hdmgdj-container py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-8 md:gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="w-11 h-11 flex items-center justify-center rounded-lg overflow-hidden bg-foreground-950 ring-1 ring-primary-500/40">
                <img src={HDMGDJ_LOGO} alt="黄豆魔改短剧" className="w-11 h-11 object-cover" />
              </span>
              <span className="font-heading text-[22px] text-foreground-950 tracking-wide">
                {config.siteName}
              </span>
            </div>
            <p className="mt-4 text-[14px] leading-7 text-foreground-700 max-w-md">
              黄豆魔改短剧官方站点，专注经典影视的魔改再创作。提供黄豆魔改短剧APP下载与免费版下载，Android、iOS、HarmonyOS、Windows 全平台畅看。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {config.platforms.map((p) => (
                <span
                  key={p.key}
                  className="inline-flex items-center gap-1.5 h-8 px-3 rounded-full bg-background-50 border border-secondary-200 text-[12px] font-label text-foreground-700"
                >
                  <i className={`${p.icon} text-sm text-primary-600`} />
                  {p.shortName}
                </span>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-[16px] font-bold text-foreground-950 font-label">
              <a href="#hdmgdj-top" onClick={handleJump("hdmgdj-top")} className="cursor-pointer">
                站内模块
              </a>
            </h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-3">
              {hdmgdjSections.map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    onClick={handleJump(item.id)}
                    className="text-[14px] font-label text-foreground-700 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="text-[16px] font-bold text-foreground-950 font-label">
              <a href="#hdmgdj-faq" onClick={handleJump("hdmgdj-faq")} className="cursor-pointer">
                联系我们
              </a>
            </h4>
            <div className="mt-4 space-y-3 text-[14px] font-label">
              <div className="flex items-start gap-2">
                <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5 text-primary-700">
                  <i className="ri-mail-line" />
                </span>
                <span className="text-foreground-700">
                  联系邮箱：<span className="text-foreground-950 font-bold">{config.contactEmail}</span>
                </span>
              </div>
              <div className="flex items-start gap-2">
                <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5 text-primary-700">
                  <i className="ri-global-line" />
                </span>
                <span className="text-foreground-700">官方网站：{config.domain}</span>
              </div>
              <div className="flex items-start gap-2">
                <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5 text-primary-700">
                  <i className="ri-time-line" />
                </span>
                <span className="text-foreground-700">客服时间：周一至周日 9:00 - 22:00</span>
              </div>
            </div>
            <Link
              to="/hdmgdj-download"
              className="mt-5 inline-flex items-center gap-2 h-10 px-5 rounded-md bg-foreground-950 text-background-50 text-[14px] font-label font-bold whitespace-nowrap hover:bg-foreground-900 transition-colors cursor-pointer"
            >
              <i className="ri-download-2-line text-lg" />
              前往下载页
            </Link>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-300 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-[13px] font-label text-foreground-600">
            © 2026 {config.siteName} · {config.domain} 版权所有
          </p>
          <p className="text-[12px] font-label text-foreground-500">
            本站内容仅供学习交流，请支持正版影视作品。
          </p>
        </div>
      </div>
    </footer>
  );
}